import "swiper/swiper-bundle.css";

import { FreeMode, Mousewheel, Pagination } from "swiper/modules";

import Swiper from "swiper";

Array.from(document.querySelectorAll(".suggested-posts.swiper")).map((post) => {
	const swiper = new Swiper(post, {
		modules: [Pagination, FreeMode, Mousewheel],
		slidesPerView: 1.25,
		spaceBetween: 16,
		freeMode: true,
		mousewheel: false,
		grabCursor: false,
		autoHeight: true,
		pagination: {
			el: post.querySelector(".swiper-pagination"),
			type: "progressbar",
		},
		autoHeight: true,
		breakpoints: {
			768: {
				slidesPerView: 2.5,
			},
		},
	});
});
